var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list)?_c('el-image',{ref:"previewImage",attrs:{"alt":_vm.alt,"src":_vm.url,"preview-src-list":_vm.list}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }